import JobNameReducer from "@wausauCustomBlueprint/Store/Data/JobNameReducer";
import WausauRequestRMAReducer from "@wausauCustomBlueprint/Store/Data/RequestRMA/WausauRequestRMAReducer";
import ShipCompleteReducer from "@wausauCustomBlueprint/Store/Data/ShipCompleteReducer";

import { combineReducers } from "redux";

const dataReducers = {
    jobNameState: JobNameReducer,
    shipCompleteState: ShipCompleteReducer,
    wausauRequestRMAState: WausauRequestRMAReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);

export default dataReducer;
